/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import _map from 'lodash/map'
import {luckyHiyaSlice, PageTypeEnum} from '~/pages/game/LuckyHiya/reducers'

export const getBullets = createAsyncThunk(
  'LuckyGift/new_lucky_marquee',
  async (p: any, store: any) => {
    const resp = await http.post('/live/gift/new_lucky_marquee', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export const getHomeRankData = createAsyncThunk(
  'LuckyGift/new_lucky_rank',
  async (p: any, store: any) => {
    const resp = await http.post('/live/gift/new_lucky_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)
export const getLuckyStarRankData = createAsyncThunk(
  'LuckyGift/lucky_star_rank',
  async (p: any, store: any) => {
    const resp = await http.post('/live/gift/lucky_star_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
      offset: 0,
      limit: 30,
    })
    return resp.data.data
  }
)

const transformMemInfo = (info) => {
  return {
    score: info.score,
    rank: info.rank <= 0 ? '-' : info.rank > 30 ? '30+' : info.rank,
    name: info.member_info.name,
    avatar: info.member_info.avatar,
    mid: info.member_info.id,
  }
}

export interface user_info {
  mid: number
  rank: number
  score: number
  coin: number
  cnt: number
  reveal_times: number
  avatar: string
  name: string
  remark: string
  gift_name: string
  gift_icon: string
  reelection_cnt: string
  ct: string
  lucky_gifts?: Array<{
    id?: number
    icon?: string
  }>
}

const initialState: {
  rankList?: Array<user_info>
  bullets?: Array<user_info>
  own?: user_info
  last_top?: user_info
  countdown?: number
  init: boolean
  lucky_stars?: Array<user_info>
} = {
  init: true,
}

export const LuckyGiftSlice = createSlice({
  name: 'LuckyGift',
  initialState,
  reducers: {
    changeInit: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        init: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBullets.fulfilled, (state, action) => {
      const {list} = action.payload
      Object.assign(state, {bullets: list})
    })
    builder.addCase(getHomeRankData.fulfilled, (state, action) => {
      const {list, own, last_top, countdown} = action.payload
      Object.assign(state, {
        rankList: list,
        last_top,
        countdown,
        own: {
          ...own,
          rank: own.rank <= 0 ? '-' : own.rank > 30 ? '30+' : own.rank,
        },
      })
    })
    builder.addCase(getLuckyStarRankData.fulfilled, (state, action) => {
      const {list, own, lucky_stars, count_down} = action.payload
      Object.assign(state, {
        rankList: _map(list, (info) => transformMemInfo(info)),
        lucky_stars: _map(lucky_stars, (info) => ({...info, mid: info.id})),
        countdown: count_down,
        own: transformMemInfo(own),
      })
    })
  },
})

export default LuckyGiftSlice.reducer
export const LuckyGiftActions = LuckyGiftSlice.actions
